import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild, WritableSignal, effect,
} from '@angular/core';
import {MapComponent} from "@components/map/map.component";
import {Router, RouterLink} from "@angular/router";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {RegionService} from "@6grain/masofa-monolith-api-client/dictionaries/api/region.service";
import {CropService} from "@6grain/masofa-monolith-api-client/dictionaries/api/crop.service";
import {MessageService} from "primeng/api";
import {BidTypeService} from "@6grain/masofa-monolith-api-client/dictionaries/api/bidType.service";
import {NotReadyApiService} from "@app/api/not-ready-api-service";
import {PrimeNG} from "primeng/config";
import {DateFormatLangPipe} from "@app/utils/pipes/date-format-lang-pipe";
import {MsfSelect} from "@components/select/select";
import {FormsModule} from "@angular/forms";
import {MsfInput} from "@components/ui/forms/input/input";
import {ButtonDirective} from "primeng/button";
import {Divider} from "primeng/divider";
import {DatePipe, NgIf, NgClass} from "@angular/common";
import {CheckboxComponent} from "@components/checkbox";
import {TextareaComponent} from "@components/textarea";
import {GetByIdPipe} from "@app/utils/pipes/get-by-id-pipe";
import {DatePickerComponent} from "@components/date-picker";
import {OpenlayersMapComponent} from "@components/openlayers-map/openlayers-map.component";
import {
  Bid,
  Field,
  FieldService,
  Season,
  SeasonBaseGetQuery,
  SeasonService
} from "@6grain/masofa-monolith-api-client/crop-monitoring";
import {BidStateType} from "@6grain/masofa-monolith-api-client/crop-monitoring/model/bidStateType";
import {UserService} from "@6grain/masofa-monolith-api-client/identity";
import {DialogComponent} from "@components/dialog";
import {Subject} from "rxjs";
import {
  FieldFilter,
  FilterOperator as DictionaryFilterOperator,
  Region,
  RegionMap,
  RegionMapService,
  Variety,
  VarietyService
} from "@6grain/masofa-monolith-api-client/dictionaries";
import {ServerTranslatePipe} from "@app/utils/pipes/server-translate-pipe";

import {FilterOperator} from "@6grain/masofa-monolith-api-client/crop-monitoring/model/filterOperator";
import {SaveButton} from "@components/button/save-button/save-button/save-button";
import {environment} from '@root/src/environments/environment';
import {userNames} from '@app/utils/_msf';
import {Toast} from 'primeng/toast';
import {Loading} from '@components/ui/loading/loading';
import {RequestMapComponent} from '@components/request-map/request-map.component2';
import { RequestResultModalComponent } from '../../../request-result-modal/request-result-modal.component';
import {MsfSelectPaginated} from '@components/select/paginated/select-paginated';
import {MsfTreeSelect} from '@components/tree-select/tree-select';
import {RegionManagerService} from '@components/openstreetmap/managers/region-manager.service';
import {BID_STATUS_USES, BidStatus} from '@shared/data/bid-status-uses-data';
import {
  BID_WORK_TYPE_IDS,
  resolveBidWorkType,
} from '@shared/data/bid-work-type.util';
import {BidWorkTypeService} from '@6grain/masofa-monolith-api-client/dictionaries/api/bidWorkType.service';


export interface BidFormData extends Bid {
  // inspectionStatus?: boolean;
  polygonJson?: any;
  polygon?: string;
  isPublished?: boolean;
  contour?: number;
  taskContent?: string;
  archived?: boolean;
  active?: boolean;
  cancelled?: boolean;
  seedingDate?: string;
  completionDate?: string;
  author?: string;
  flightTarget?: string;
  publish?: boolean;
  archive?: boolean;
  anomalyPolygonId?: string | null;
  bidWorkType?: number;
}


@Component({
  selector: 'app-ground-survey',
  standalone: true,
  templateUrl: './ground-survey.html',
  styleUrl: './ground-survey.scss',
  providers: [
    TranslatePipe,
    DateFormatLangPipe,
    DatePipe,
  ],
  imports: [
    TranslatePipe,
    DateFormatLangPipe,
    MsfSelect,
    FormsModule,
    MsfInput,
    ButtonDirective,
    Divider, NgIf,
    CheckboxComponent,
    TextareaComponent, GetByIdPipe,
    DatePickerComponent,
    DialogComponent,
    NgClass,
    ServerTranslatePipe,
    SaveButton, Toast, Loading, RequestMapComponent,
    RequestResultModalComponent, MsfSelectPaginated, MsfTreeSelect,
    RouterLink,
  ]
})
export class GroundSurvey implements OnInit {
  protected readonly BidStateType = BidStateType;

  @ViewChild(MapComponent) mapComponent!: MapComponent;
  @ViewChild('groundMap') groundMap!: OpenlayersMapComponent;
  @ViewChild(RequestResultModalComponent) requestResultModal!: RequestResultModalComponent;

  uploadedImage = signal<string | null>(null);
  showPointModal = signal(false);
  isLoadingData = signal(false);

  private _pendingSave = false;

  public _bid!: Bid

  showPointModalValue = false;
  pendingMapClick: { lat: number; lng: number } | null = null;
  formData!: BidFormData
  readonly statusOptions: BidStatus[] = [];

  downloading: boolean = false;
  showModalDownload: boolean = false;
  public author!: string | null | undefined;
  public lastUpdateUser!: string;
  public workerName!: string;
  public foremanTouched = false;
  public latTouched = false;
  public lngTouched = false;
  public bidTypeTouched = false;
  public deadlineTouched = false;
  public cropTouched = false;


  isRegion = signal(false);
  isSowingDate = signal(false);
  isCrop = signal(true);
  isField = signal(true);
  isVariety = signal(false);
  isVarietyLoading = signal(false);
  today = signal(new Date());
  minDeadline:WritableSignal<any> = signal(null);

  fieldPolygon = signal('');

  private $coordinateChange = new Subject<{ lat: number; lng: number }>();
  private fieldSeasons: Season[] = [];

  varietyOptions: Variety[] = [];
  showContinueWithoutFiledDialog = false;
  showResultPreview = false;
  showContinueWithoutVarietyDialog: boolean = false
  isVarietyEnabled: boolean = false;


  constructor(
    private router: Router,
    public tr: TranslateService,
    public regionService: RegionService,
    public regionManagerService: RegionManagerService,
    public varietyService: VarietyService,
    public cropService: CropService,
    public fieldService: FieldService,
    public seasonService: SeasonService,
    private userService: UserService,
    public bidTypeService: BidTypeService,
    public bidWorkTypeService: BidWorkTypeService,
    public notReadyApiService: NotReadyApiService,
    public primeng: PrimeNG,
    private messageService: MessageService,
    private regionMapService: RegionMapService,
  ) {
    this.resetForm();

    effect(() => {
      let saving: boolean;
      try {
        saving = (this.isSaving as any) ? (this.isSaving as any)() : false;
      } catch (e) {
        saving = false;
      }

      if (!saving && this._pendingSave) {
        this._pendingSave = false;
      }
    });
  }


  @Output() save = new EventEmitter<BidFormData>();
  @Output() cancel = new EventEmitter<void>();
  @Output() bidChange = new EventEmitter<Bid>();

  @Input() isSaving = signal(false);
  @Input() isCanceling = signal(false);

  @Input() set bid(value: Bid) {
    if (value) {
      this._bid = value;
      if (this._bid.id) {
        this.loadMetadata();
        // this.toggleInput();
      }
      this.formData = {
        ...this.formData,
        ...value,
        bidWorkType: resolveBidWorkType((value as BidFormData).bidWorkType),
        polygonJson: value.polygonJson as any,
        publish: parseInt(value.bidState as any)  > BidStateType.NUMBER_0
      };
      if (this.formData.deadlineDate) {
        this.formData.deadlineDate = new Date(this.formData.deadlineDate) as any;
        this.minDeadline.set(this.formData.deadlineDate);
        // this.minDeadline.set(new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate()));
      } else {
        this.minDeadline.set(new Date());
      }
      this.uploadedImage.set(value.fileResultId ? `file://${value.fileResultId}` : null);
      this.loadVarietiesForCrop(this.formData.cropId);

    } else {
      this.resetForm();
    }
  }

  ngOnInit() {
    this.statusOptions.splice(0, this.statusOptions.length, ...BID_STATUS_USES);
    this.$coordinateChange.subscribe(coords => {
      this.loadFieldByPoints(true, coords.lat, coords.lng);
      this.loadRegionByPoint( coords.lat, coords.lng);
    });
    this.loadTaskType();

    if (!this.formData.regionId){
      this.loadRegionByPoint(this.formData.lat as number, this.formData.lng as number);
    }
  }


  loadSeasonsField() {
    if (this.formData.fieldId) {
      const query: SeasonBaseGetQuery = {
        filters: [
          {
            filterField: 'fieldId',
            filterOperator: FilterOperator.NUMBER_0,
            filterValue: this.formData.fieldId
          }
        ]
      }

      this.seasonService.cropMonitoringSeasonGetByQueryPost(query).subscribe({
        next: (seasons: Season[]) => {
          this.fieldSeasons = seasons;
        },
        error: () => {
        }
      })
    }
  }


  loadRegionByPoint(lat: number, lng: number) {
    this.regionService.dictionariesRegionGetRegionByPointGet(lng, lat)
      .subscribe(region => {
      this.formData.regionId = region.id;
    })
  }
  loadFieldByPoints(dialogMode = true, lat = this.formData.lat, lng = this.formData.lng) {
    this.isLoadingData.set(true);
    this.fieldService.cropMonitoringFieldGetByPointsGet(lng, lat).subscribe({
      next: (field: Field) => {
        this.isLoadingData.set(false);
        if (field && field.id) {
          this.formData.fieldId = field.id;
          if (field.regionId) {
            this.formData.regionId = field.regionId;
          }
          this.formData.regionId = field.regionId;
          //@ts-ignore
          this.loadSeasonsField();
          this.isCrop.set(true);
          if (dialogMode) {
            this.showContinueWithoutFiledDialog = false;
          }

        } else {
          if (dialogMode) {
            this.showContinueWithoutFiledDialog = true;
          }
        }
      },
      error: () => {
        this.isLoadingData.set(false);
        if (dialogMode) {
          this.showContinueWithoutFiledDialog = true;
        }
      }
    })
  }

  enabledFieldDeps() {
    if (this.formData.fieldId) {
      this.isRegion.set(true);
      this.isCrop.set(true);
      this.isSowingDate.set(true);
      this.isVariety.set(true);
    }

  }


  saveRequest() {
    this.foremanTouched = true;
    this.latTouched = true;
    this.lngTouched = true;
    this.bidTypeTouched = true;
    this.deadlineTouched = true;
    this.cropTouched = true

    if (!this.isFormValid()) {
      return;
    }

    const clonedData = {...this.formData};

    this._pendingSave = true;
    try {
      (this.isSaving as unknown as WritableSignal<boolean>).set(true);
    } catch (e) {
    }

    this.bidChange.emit(clonedData);
    this.save.emit(clonedData);
  }

  updateLocalBidState() {
    if (this.formData.bidState !== BidStateType.NUMBER_5) {
      if (this.formData.publish && !this.formData.archive) {
        this.formData.bidState = BidStateType.NUMBER_1;
      } else {
        this.formData.bidState = BidStateType.NUMBER_0;
      }
    }
  }

  onMapClick(coordinate: { lat: number; lng: number }) {
    this.pendingMapClick = {
      lat: coordinate.lat,
      lng: coordinate.lng
    };
    this.showPointModalValue = true;
    this.showPointModal.set(true);
  }

  confirmPointChange() {
    if (this.pendingMapClick) {
      this.formData.lat = this.pendingMapClick.lat;
      this.formData.lng = this.pendingMapClick.lng;
      this.pendingMapClick = null;
      this.$coordinateChange.next({lat: this.formData.lat, lng: this.formData.lng});
    }
    this.showPointModalValue = false;
    this.showPointModal.set(false);
  }

  cancelPointChange() {
    this.pendingMapClick = null;
    this.showPointModalValue = false;
    this.showPointModal.set(false);
  }

  onMarkerClick(coordinate: { lat: number; lng: number }) {
    // Show modal when clicking on existing marker
    this.onMapClick(coordinate);
  }

  onCoordinatesChange(lat = this.formData.lat, lng = this.formData.lng) {
    // Update map center when coordinates are manually changed
    if (lng && lat) {
      this.$coordinateChange.next({lat, lng});
    }
  }

  onFieldChange(field: Field) {
    this.loadSeasonsField();
    this.formData.regionId = field.regionId;
    if (field.centerX && field.centerY) {
      this.formData.lat = field.centerY as number;
      this.formData.lng = field.centerX as number;
    }
    this.onPolygonFieldChange(field);
  };
  onPolygonFieldChange(field: Field) {
    if (field.polygonJson) {
      this.fieldPolygon.set(field.polygonJson);
    }
  };
  loadRegionMap(id:string) {
    this.isLoadingData.set(true);
    this.regionMapService.dictionariesRegionMapGetByIdIdGet(id).subscribe({
      next: (regionMap: RegionMap) => {
        this.isLoadingData.set(false);
        this.formData.lat = regionMap.lat as number;
        this.formData.lng = regionMap.lng as number;
        this.$coordinateChange.next({lat: this.formData.lat, lng: this.formData.lng});
      },
      error: () => {
      }
    })
  }


  onRegionChange(region:Region) {
    if (region) {
      const regionMapId = region.regionMapId;
      this.loadRegionMap(regionMapId as string)
    }
  }


  loadMetadata() {
    if (this._bid.createUser) {
      this.userService.identityUserGetByIdIdGet(this._bid.createUser as string).subscribe({
        next: (response) => {
          if (response && response.userName) {
            this.author = userNames(response);
          }
        },
      })

      if (this._bid.lastUpdateUser) {
        this.userService.identityUserGetByIdIdGet(this._bid.lastUpdateUser as string).subscribe({
          next: (response) => {
            if (response) {
              this.lastUpdateUser = userNames(response)
            }
          },
        })
      }

      if (this._bid.workerId) {
        this.userService.identityUserGetByIdIdGet(this._bid.workerId as string).subscribe({
          next: (response) => {
            if (response) {
              this.workerName =  userNames(response)
            }
          },
        })
      }
    }
  }


  removeImage(event?: Event) {
    event?.stopPropagation();
    this.uploadedImage.set(null);
  }


  resetForm(): void {
    this.formData = {
      id: undefined,
      createAt: undefined,
      lastUpdateAt: undefined,
      foremanId: null,
      bidState: BidStateType.NUMBER_0,
      // bidTypeId: BID_STATUS.New,
      description: '',
      comment: '',
      deadlineDate: undefined,
      regionId: null,
      cropId: undefined,
      customer: null,
      active: true,
      cancelled: false,
      publish: false,
      bidWorkType: BID_WORK_TYPE_IDS.Default,
      lat: environment.map.lat,
      lng: environment.map.lng,
    };
    console.log('FormData after resetForm:', this.formData);
    this.varietyOptions = [];


    // Reset uploaded image
    this.removeImage()
  }


  downloadBidFile() {
    const fileId = this.formData.fileResultId as string;

    if (!fileId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No file',
        detail: 'No result file attached to this request',
        life: 3000
      });
      return;
    }

    // Open the RequestResultModalComponent which will handle downloading and showing the contents
    if (this.requestResultModal && typeof this.requestResultModal.open === 'function') {
      this.requestResultModal.open(fileId);
    } else {
      // Fallback: show error to user
      console.warn('RequestResultModalComponent not available to open file result');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unable to open result modal',
        life: 3000
      });
    }
  }


  notContinueWithoutField() {
    this.showContinueWithoutFiledDialog = false;
    this.router.navigate(['/crop-monitoring/requests/add']);
  }

  anomalyPolygonLinkId(): string | null {
    const raw =
      this.formData?.anomalyPolygonId ??
      (this._bid as {anomalyPolygonId?: string | null})?.anomalyPolygonId;
    if (raw == null || raw === '') {
      return null;
    }
    return String(raw);
  }

  isFormValid(): boolean {
    return !!(
      this.formData.lat &&
      this.formData.lng &&
      this.formData.deadlineDate &&
      this.formData.foremanId &&
      this.formData.cropId
    );
  }

  continueWithoutField() {
    this.isCrop.set(true);
    this.isRegion.set(true);
    this.isSowingDate.set(true);
    this.isVariety.set(true);
    this.isField.set(false);
    this.showContinueWithoutFiledDialog = false;
    this.showContinueWithoutVarietyDialog = false;
    // Reset the field according to the context (update or creation)
    if (this.formData.fieldId) {
      if (this._bid && this._bid.fieldId) {
        this.formData.fieldId = this._bid.fieldId;
      } else {
        this.formData.fieldId = null;
      }
    }
  }

  onCropChange() {
    const foundedCropSeason = this.fieldSeasons?.find(season => season.cropId === this.formData.cropId)
    this.formData.varietyId = undefined;
    this.varietyOptions = [];
    this.loadVarietiesForCrop(this.formData.cropId);

    if (foundedCropSeason) {
      if (!this.formData.fieldPlantingDate){
        this.formData.fieldPlantingDate = new Date(foundedCropSeason.startDate as string).toISOString();
      }
    } else {
      if (!this.formData.fieldPlantingDate){
        this.formData.fieldPlantingDate = undefined;
      }
      this.showContinueWithoutVarietyDialog = false;
    }
    this.isVarietyEnabled = !!this.formData.cropId;
  }

  private loadVarietiesForCrop(cropId?: string | null) {
    this.isVarietyEnabled = !!cropId;

    if (!cropId) {
      this.varietyOptions = [];
      this.formData.varietyId = undefined;
      this.isVarietyLoading.set(false);
      return;
    }

    this.isVarietyLoading.set(true);
    const filters: FieldFilter[] = [
      {
        filterField: 'CropId',
        filterOperator: FilterOperator.NUMBER_0,
        filterValue: cropId,
      },
    ];

    this.varietyService
      .dictionariesVarietyGetByQueryPost({ filters })
      .subscribe({
        next: (varieties: Variety[]) => {
          this.varietyOptions = [...(varieties ?? [])];
          this.isVarietyLoading.set(false);
        },
        error: (error) => {
          console.error('Error loading varieties:', error);
          this.varietyOptions = [];
          this.formData.varietyId = undefined;
          this.isVarietyLoading.set(false);
        }
      });
  }

  onDialogShow(): void {
    setTimeout(() => {
      if (this.groundMap) {
        //@ts-ignore
        this.groundMap.updateCenterMarker(this.formData.lat, this.formData.lng);
// Ensure the map resizes properly
      }
    }, 0);
  }

  isFutureDate(date: string | Date | null | undefined): boolean {
    if (!date) return false;

    const parsed = typeof date === 'string' ? new Date(date) : date;
    return parsed > this.today();
  }

  loadTaskType() {
    this.bidTypeService.dictionariesBidTypeGetByQueryPost({}).subscribe({
      next: (bidTypes) => {
        if (bidTypes.length > 0){
          this.formData.bidTypeId = bidTypes[0]?.id;

        }
      },
      error: (error) => {
        console.error('Error loading bid types:', error);
      }
    })
  }

  regionChanged() {

  }
}
